import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPendingDuesReport } from "../../services/pending.services";

export const fetchPendingDuesReport = createAsyncThunk(
  "pendingDuesReport/fetch",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getPendingDuesReport(groupBy);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const pendingDuesSlice = createSlice({
  name: "pendingDuesReport",
  initialState: {
    monthly: [], // Monthly pending dues data
    yearly: [], // Yearly pending dues data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingDuesReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPendingDuesReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.meta.arg === "month") {
          state.monthly = action.payload.monthly_pending_dues || [];
        } else if (action.meta.arg === "year") {
          state.yearly = action.payload.yearly_pending_dues || [];
        }
      })
      .addCase(fetchPendingDuesReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default pendingDuesSlice.reducer;
